// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box, Button, Dialog, DialogContent, TextField, Typography } from '../../../lib/base';
import { ExitDialogButton } from '../button';

interface Props {
  readonly onSubmit: () => void;
  readonly onClose: () => void;
  readonly description: string;
  readonly title: string;
  readonly open: boolean;
  readonly extraConfirmation?: string;
  readonly extra?: React.ReactNode;
  readonly disableSubmit?: boolean;
}

export default function Confirmation({
  onSubmit,
  onClose,
  description,
  title,
  open,
  extraConfirmation,
  extra,
  disableSubmit,
}: Props) {
  const [confirmationInput, setConfirmationInput] = React.useState('');
  const onChangeConfirmationInput = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setConfirmationInput(event.target.value);
  };
  const needsExtraConfirmation = extraConfirmation !== undefined;

  return (
    <Dialog
      open={open}
      onClose={() => {
        setConfirmationInput('');
        onClose();
      }}
      maxWidth="sm"
    >
      <DialogContent>
        <Box sx={{ p: 0 }} display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center">
          <ExitDialogButton
            onCloseDialog={() => {
              setConfirmationInput('');
              onClose();
            }}
          />
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography sx={{ mb: 1 }} variant="h4">
              {title}
            </Typography>
            <Typography variant="body1">{description}</Typography>
          </Box>
          {extra && <Box>{extra}</Box>}
          {needsExtraConfirmation ? (
            <TextField
              aria-describedby="confirmation-input"
              id="confirmation-input"
              label={extraConfirmation ?? ''}
              value={confirmationInput}
              onChange={onChangeConfirmationInput}
            />
          ) : null}
          <Button
            sx={{ mt: 2, width: '100%' }}
            variant="outlined"
            onClick={() => {
              setConfirmationInput('');
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            sx={{ mt: 1, width: '100%' }}
            variant="contained"
            onClick={onSubmit}
            type="submit"
            disabled={(needsExtraConfirmation ? confirmationInput !== extraConfirmation : false) || disableSubmit}
          >
            Submit
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
